import script from "./BalancesHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalancesHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BalancesHeader.vue?vue&type=style&index=0&id=4b5c8d80&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5c8d80"]])

export default __exports__